import { render, staticRenderFns } from "./material-dialog.vue?vue&type=template&id=652a47a4&scoped=true&"
import script from "./material-dialog.vue?vue&type=script&lang=js&"
export * from "./material-dialog.vue?vue&type=script&lang=js&"
import style0 from "./material-dialog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./material-dialog.vue?vue&type=style&index=1&id=652a47a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a47a4",
  null
  
)

export default component.exports